module.exports = __webpack_public_path__ + "static/media/bgi-hiring-manager@2x.0467550d.png";